import { useState } from 'react';

export type PWG201Mode = 'browse' | 'add' | 'edit';

export function usePWG201Mode() {
  const [mode, setMode] = useState<PWG201Mode>('browse');

  const isEditing = mode === 'add' || mode === 'edit';

  const startAdd = () => setMode('add');
  const startEdit = () => setMode('edit');
  const exitEdit = () => setMode('browse');

  return { mode, setMode, isEditing, startAdd, startEdit, exitEdit };
}
